import api from "@/lib/api";
import { toast } from "sonner";

export function detectCurrency() {
  try {
    const lang = (navigator.language || "").toLowerCase();
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    if (lang.startsWith("sv") || tz === "Europe/Stockholm") return "sek";
  } catch {
    // fall through to usd
  }
  return "usd";
}

export const PRICES = {
  usd: { symbol: "$", pos: "before", monthly: 19, intro: 9, annual: 149 },
  sek: { symbol: "kr", pos: "after", monthly: 190, intro: 89, annual: 1490 },
};

export function fmt(amount, currency) {
  const p = PRICES[currency];
  return p.pos === "before" ? `${p.symbol}${amount}` : `${amount} ${p.symbol}`;
}

export async function startCheckout(plan) {
  try {
    const { data } = await api.post("/billing/checkout", {
      plan,
      currency: detectCurrency(),
      origin_url: window.location.origin,
    });
    window.location.href = data.checkout_url;
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Could not start checkout — try again");
  }
}
